var render = function render(){var _vm=this,_c=_vm._self._c;return _c('order-summary',{attrs:{"billing-array":_vm.activeReloadFormBilling.billingArray,"is-billing-final":_vm.activeReloadFormBilling.isBillingFinal,"errors":_vm.activeReloadFormBillingReloadError,"loading":_vm.activeReloadFormBillingLoading}})
}
var staticRenderFns = []

export { render, staticRenderFns }